var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 44,
    viewBox: "0 0 42 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5 11.2619C3.5 9.36116 4.2375 7.53829 5.55025 6.19428C6.86301 4.85027 8.64348 4.09521 10.5 4.09521H31.5C33.3565 4.09521 35.137 4.85027 36.4497 6.19428C37.7625 7.53829 38.5 9.36116 38.5 11.2619V32.7619C38.5 34.6626 37.7625 36.4855 36.4497 37.8295C35.137 39.1735 33.3565 39.9285 31.5 39.9285H10.5C8.64348 39.9285 6.86301 39.1735 5.55025 37.8295C4.2375 36.4855 3.5 34.6626 3.5 32.7619V11.2619Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.875 20.2201C17.2912 20.2201 19.25 18.2147 19.25 15.7409C19.25 13.2671 17.2912 11.2617 14.875 11.2617C12.4588 11.2617 10.5 13.2671 10.5 15.7409C10.5 18.2147 12.4588 20.2201 14.875 20.2201Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4205 23.1243L10.5 39.9283H31.7327C33.5275 39.9283 35.2488 39.1984 36.5179 37.8991C37.787 36.5997 38.5 34.8375 38.5 33V32.7617C38.5 31.9268 38.1937 31.6061 37.6425 30.9879L30.59 23.1136C30.2613 22.7465 29.8615 22.4536 29.4161 22.2535C28.9706 22.0535 28.4893 21.9507 28.0029 21.9517C27.5165 21.9527 27.0357 22.0575 26.591 22.2594C26.1464 22.4613 25.7477 22.7559 25.4205 23.1243V23.1243Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImage);
export default __webpack_public_path__ + "static/media/NoImage.4d1de903ef02d887317fd7e9b0e88dc9.svg";
export { ForwardRef as ReactComponent };